import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';

new Accordion('[data-accordion]', {
  duration: 400,
  showMultiple: false,
});
